import { render, staticRenderFns } from "./SpecialOfferAlert.vue?vue&type=template&id=52cfb0d7&scoped=true"
import script from "./SpecialOfferAlert.vue?vue&type=script&lang=js"
export * from "./SpecialOfferAlert.vue?vue&type=script&lang=js"
import style0 from "./SpecialOfferAlert.vue?vue&type=style&index=0&id=52cfb0d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfb0d7",
  null
  
)

/* custom blocks */
import block0 from "./SpecialOfferAlert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports